export const Translatable = {
	methods: {
		dctxt(key) {
			if (typeof window.dcpgData.txt !== 'undefined' && typeof window.dcpgData.txt[key] !== 'undefined') return window.dcpgData.txt[key];
			return key;
		}
	}
}